import { zxcvbn } from '@zxcvbn-ts/core';

const estimatePasswordStrength = (password = '', userInputs) => zxcvbn(password, userInputs);

export default estimatePasswordStrength;
